import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { UserContext } from '@/app/UserProvider';
import { FormLayout } from '@/components/common/FormLayout';
import { PageLayout } from '@/components/common/PageLayout';
import { LoginForm } from '@/components/login/LoginForm';

import { LoginSuccess } from './LoginSuccess';

export default function LoginIndex() {
  const { hasToken } = useContext(UserContext);
  const { t } = useTranslation();

  // 如果存在 token，优先展示 LoginSuccess（LoginSuccess 组件内部会处理加载状态和用户验证）
  if (hasToken) {
    return (
      <PageLayout>
        <LoginSuccess />
      </PageLayout>
    );
  }

  // 没有 token，显示登录表单
  return (
    <PageLayout>
      <FormLayout title={t('auth.login.title')}>
        <LoginForm />
      </FormLayout>
    </PageLayout>
  );
}